import App from './Components/App';
import ReactDOM from 'react-dom';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery/dist/jquery.js';
import 'popper.js/dist/umd/popper.js';
import 'bootstrap/dist/js/bootstrap.js';
import { logger } from 'redux-logger';
import './CSS/table.css';
import thunk from 'redux-thunk';
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import CombinedReducer from './Reducers/CombinedReducer';
import {Provider} from 'react-redux';
import './CSS/Resources.css';
import './CSS/table.css';
import swDev from './swDev';

const store = createStore(CombinedReducer,
  composeWithDevTools(
  applyMiddleware(thunk, logger)
  )
  )

  ReactDOM.render(
    <Provider store = {store} >
        <App />
    </Provider>,
   document.getElementById('root')
 );
  
swDev();